import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef
} from "@angular/material/legacy-dialog"
import { CTMGeneralService } from '../../../_core/lib/general.service';
import { FormBuilder } from '@angular/forms';
import { TaskLeadRouteData } from '../../../_core/route-data/task-lead.route-data';
import { CtButtonConfiguration, CtFormConfiguration, CtModelConfiguration, CtModelService, CtSelectControlValue, MAT_RAISED_ACCENT, MAT_RAISED_WARN } from '@ctsolution/ct-framework';
import { Task_Lead } from '../../../_core/classes/task_lead';
import { isNil, omitBy } from 'lodash';
import { CtWebapiGenericResponse } from '@ctsolution/ct-webapi';
import { TaskLeadEditConfiguration } from './task-lead-edit.configuration';

@Component({
  selector: 'app-task-lead-edit',
  templateUrl: './task-lead-edit.component.html',
  styleUrls: ['./task-lead-edit.component.scss']
})
export class TaskLeadEditComponent implements OnInit {

  configuration: CtFormConfiguration | null = null;

  cancelButton = CtButtonConfiguration.create()
    .setLabel("CT_PAGE.CT_FORM.cancel")
    .setAction(() => this.dialogRef.close())
    .setMatherialOptions(MAT_RAISED_WARN);

  submitButton = CtButtonConfiguration.create()
    .setLabel("CT_PAGE.CT_FORM.save")
    .setClass('ct-model-submit-button')
    .setAction(() => this.onSubmit())
    .setMatherialOptions(MAT_RAISED_ACCENT);

  constructor(
    private dialogRef: MatDialogRef<TaskLeadEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: TaskLeadEditConfiguration,
    private generalService: CTMGeneralService,
    private formBuilder: FormBuilder,
    private modelService: CtModelService<any>
  ) { }

  ngOnInit() {

    this.setup();

  }

  async setup() {

    this.configuration = await this.generalService.getFormConfiguration(this.formBuilder.group({}), TaskLeadRouteData());

    if (this.data?.data)
      this.setupForm();

    if (this.configuration?.form?.controls['Task'] && this.data?.taskOid)
      this.configuration?.form?.controls['Task'].setValue(this.data?.taskOid);

    if(this.data?.selectedLead){

      const control = this.configuration.controls?.find(c => c.name === 'Lead');
      control?.setValue(CtSelectControlValue.create().setValue(this.data?.selectedLead.Oid).setLabel(this.data?.selectedLead.ReferenceName)).setDisabled(true);

    }

  }

  onSubmit() {


    if (this.configuration?.form?.invalid || !this.configuration?.form?.controls['Task']?.value) return;

    const taskData: Task_Lead = Task_Lead.create(this.configuration?.form?.getRawValue());

    const modelConfiguration = CtModelConfiguration.create().setRouteData(TaskLeadRouteData());

    if (taskData.Oid) modelConfiguration.RouteData?.setId(taskData.Oid);

    if (this.configuration?.form?.controls['Lead']?.value?.value)
      taskData.setLeadOid(this.configuration?.form?.controls['Lead']?.value?.value);

    taskData.setTaskOid(this.configuration?.form?.controls['Task']?.value); //Do per scontato ci sia sempre il valore del task

    const filtered = omitBy(taskData, isNil);   // Mi rimuove i campi null 

    this.modelService.putInfos(modelConfiguration, filtered)?.subscribe((result: CtWebapiGenericResponse<any>) => {

      this.dialogRef.close(result.Result);

    }, (error) => {

      console.error(error);

     });

  }


  setupForm() {

    const dataSource: Task_Lead = this.data.data!;

    this.configuration?.form?.patchValue(dataSource, { emitEvent: true });

    if (dataSource.Lead) {

      const control = this.configuration?.controls?.find(c => c.name === 'Lead');
      control?.setValue(CtSelectControlValue.create().setValue(dataSource.Lead.Oid).setLabel(dataSource.Lead?.Name ?? null));

    }

  }

}
